import Vue from 'vue'

import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate'

// extend only the rules we need for a smaller bundle size
// eslint-disable-next-line
import { required } from 'vee-validate/dist/rules'
import  messages  from 'vee-validate/dist/locale/en.json'

const rules = { required }
for (const r in rules) {
  extend(r, { ...rules[r], message: messages[r] })
}

// configure({
//   classes: {
//     invalid: 'is-invalid',
//     valid: 'is-valid',
//   },
// })

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
